import { css } from '@emotion/react';
import type { SerializedStyles } from '@emotion/react';
import { getColorStyle, isDarkColor } from './utils.styles';
import WhiteZolaFooterLogo from '../../assets/images/logos/zola-logo-minimal-white.svg';
import BlackZolaFooterLogo from '../../assets/images/logos/zola-logo-minimal.svg';

export const getFooterStyles = (backgroundColor?: string | null): SerializedStyles => {
  const finalBgColor = backgroundColor || 'FFFFFF';
  const linkColor = getColorStyle(isDarkColor(finalBgColor) ? 'FFFFFF' : '21201F');
  const logoSrc = isDarkColor(finalBgColor) ? WhiteZolaFooterLogo : BlackZolaFooterLogo;
  const logoStyle = `
    .logo {
        background-image: url(${logoSrc}) !important;
      }
    `;

  return css`
    #public-wrapper {
      #footer {
        .footer {
          ${backgroundColor && logoStyle}

          .footer-nav {
            .list-inline li {
              ${backgroundColor && linkColor}

              a {
                ${backgroundColor && linkColor}
              }
            }

            .text-muted.tos {
              ${backgroundColor && linkColor}

              a {
                ${backgroundColor && linkColor}
              }
            }
          }

          .made-with-love {
            ${backgroundColor && linkColor}
          }
        }
      }
    }
  `;
};
